// extracted by mini-css-extract-plugin
export default {"toastContent":"ToastMessage_toastContent__msSYk","svgSuccess":"ToastMessage_svgSuccess__E5BFR","svgError":"ToastMessage_svgError__tLXYU"};